"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSuspensionStatus = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _Constants = require("../Constants");

var BASE_URL = "vetting/public/v1/account-verification/state/scope";

var requestSuspensionStatus = function requestSuspensionStatus() {
  var httpClient = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _apiClient.default;
  var hostApp = arguments.length > 1 ? arguments[1] : undefined;
  var query = {
    hostApp: hostApp
  };
  return httpClient.get(BASE_URL + "/" + _Constants.FILE_MANAGER_WRITE_SCOPE, {
    query: query
  });
};

exports.requestSuspensionStatus = requestSuspensionStatus;